import 'svelte/internal/disclose-version';

Live[$.FILENAME] = 'src/web/concepts/live.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations($.from_html(`<span class="absolute inset-0 bg-ink animate-ping"></span>`), Live[$.FILENAME], [[24, 16]]);
var root_1 = $.add_locations($.from_html(`Next free slot in <span class="tabular-nums"> </span>.`, 1), Live[$.FILENAME], [[33, 34]]);
var root_2 = $.add_locations($.from_html(`<button class="btn">Call me now</button>`), Live[$.FILENAME], [[36, 16]]);

var root_3 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-4xl md:text-6xl font-semibold tracking-tight">
      <!>
    </h1>
    <div class="flex flex-wrap gap-3">
      <!>
      <button>Book a video call</button>
    </div>
  `,
		1
	),
	Live[$.FILENAME],
	[[32, 4], [35, 4, [[37, 6]]]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
      <p class="font-display text-4xl md:text-6xl font-semibold tracking-tight">Your phone rings in a few minutes.</p>
    `,
		1
	),
	Live[$.FILENAME],
	[[41, 6]]
);

var root_5 = $.add_locations(
	$.from_html(
		`
      <form class="flex flex-col gap-6">
        <label for="phone" class="font-display text-3xl md:text-5xl font-semibold tracking-tight">Your number. We call within 10 minutes.</label>
        <input id="phone" class="field text-2xl md:text-3xl" type="tel" placeholder="+33 6 12 34 56 78" required=""/>
        <button class="btn self-start">Call me</button>
      </form>
    `,
		1
	),
	Live[$.FILENAME],
	[[43, 6, [[44, 8], [45, 8], [46, 8]]]]
);

var root_6 = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	Live[$.FILENAME],
	[]
);

var root_7 = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	Live[$.FILENAME],
	[]
);

var root_8 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-3xl flex flex-col gap-10">
  <div class="flex items-center gap-3 text-lg">
    <span class="relative flex size-3">
      <!>
      <span></span>
    </span>
    <span class="font-semibold"> </span>
    <span class="opacity-60 tabular-nums"> </span>
  </div>

  <!>
</div>`,
		1
	),
	Live[$.FILENAME],
	[[21, 0, [[22, 2, [[23, 4, [[25, 6]]], [27, 4], [28, 4]]]]]]
);

function Live($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Live);

	let now = $.tag($.state($.proxy(new Date())), 'now');
	let mode = $.tag($.state("choose"), 'mode');
	let phone = $.tag($.state(""), 'phone');
	let called = $.tag($.state(false), 'called');

	$.user_effect(() => {
		const timer = setInterval(() => $.set(now, new Date(), true), 1000);

		return () => clearInterval(timer);
	});

	const paris = $.tag($.derived(() => new Date($.get(now).toLocaleString("en-US", { timeZone: "Europe/Paris" }))), 'paris');
	const open = $.tag($.derived(() => $.strict_equals($.get(paris).getDay() % 6, 0, false) && $.get(paris).getHours() >= 9 && $.get(paris).getHours() < 18), 'open');
	const clock = $.tag($.derived(() => $.get(paris).toLocaleTimeString("en-GB")), 'clock');
	const nextSlot = $.tag($.derived(() => 60 - $.get(paris).getMinutes() - ($.get(paris).getSeconds() > 0 ? 1 : 0)), 'nextSlot');
	const nextSeconds = $.tag($.derived(() => (60 - $.get(paris).getSeconds()) % 60), 'nextSeconds');
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_8();
	var div = $.sibling($.first_child(fragment));
	var div_1 = $.sibling($.child(div));
	var span = $.sibling($.child(div_1));
	var node = $.sibling($.child(span));

	{
		var consequent = ($$anchor) => {
			var span_1 = root();

			$.append($$anchor, span_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(open)) $$render(consequent);
			}),
			'if',
			Live,
			24,
			6
		);
	}

	var span_2 = $.sibling(node, 2);

	$.next();
	$.reset(span);

	var span_3 = $.sibling(span, 2);
	var text = $.only_child(span_3, true);
	var span_4 = $.sibling(span_3, 2);
	var text_1 = $.only_child(span_4);

	$.next();
	$.reset(div_1);

	var node_1 = $.sibling(div_1, 2);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_1 = root_3();
			var h1 = $.sibling($.first_child(fragment_1));
			var node_2 = $.sibling($.child(h1));

			{
				var consequent_1 = ($$anchor) => {
					var fragment_2 = root_1();
					var span_5 = $.sibling($.first_child(fragment_2));
					var text_2 = $.only_child(span_5);

					$.next();
					$.template_effect(($0) => $.set_text(text_2, `${$.get(nextSlot) ?? ''}:${$0 ?? ''}`), [() => String($.get(nextSeconds)).padStart(2, "0")]);
					$.append($$anchor, fragment_2);
				};

				var alternate = ($$anchor) => {
					var text_3 = $.text('We\'re back at 9:00, Paris time.');

					$.append($$anchor, text_3);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(open)) $$render(consequent_1); else $$render(alternate, -1);
					}),
					'if',
					Live,
					33,
					6
				);
			}

			$.next();
			$.reset(h1);

			var div_2 = $.sibling(h1, 2);
			var node_3 = $.sibling($.child(div_2));

			{
				var consequent_2 = ($$anchor) => {
					var button = root_2();

					$.delegated('click', button, function click() {
						return $.set(mode, "now");
					});

					$.append($$anchor, button);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(open)) $$render(consequent_2);
					}),
					'if',
					Live,
					36,
					6
				);
			}

			var button_1 = $.sibling(node_3, 2);

			$.next();
			$.reset(div_2);
			$.next();

			$.template_effect(() => $.set_class(button_1, 1, $.clsx($.get(open)
				? "px-6 py-3.5 border-2 border-ink font-display font-semibold"
				: "btn")));

			$.delegated('click', button_1, function click_1() {
				return $.set(mode, "later");
			});

			$.append($$anchor, fragment_1);
		};

		var consequent_5 = ($$anchor) => {
			var fragment_3 = root_6();
			var node_4 = $.sibling($.first_child(fragment_3));

			{
				var consequent_4 = ($$anchor) => {
					var fragment_4 = root_4();

					$.next(2);
					$.append($$anchor, fragment_4);
				};

				var alternate_1 = ($$anchor) => {
					var fragment_5 = root_5();
					var form = $.sibling($.first_child(fragment_5));
					var input = $.sibling($.child(form), 3);

					$.remove_input_defaults(input);
					$.autofocus(input, true);
					$.next(3);
					$.reset(form);
					$.next();

					$.event('submit', form, function submit(e) {
						e.preventDefault();
						$.set(called, true);
					});

					$.bind_value(
						input,
						function get() {
							return $.get(phone);
						},
						function set($$value) {
							$.set(phone, $$value);
						}
					);

					$.append($$anchor, fragment_5);
				};

				$.add_svelte_meta(
					() => $.if(node_4, ($$render) => {
						if ($.get(called)) $$render(consequent_4); else $$render(alternate_1, -1);
					}),
					'if',
					Live,
					40,
					4
				);
			}

			$.next();
			$.append($$anchor, fragment_3);
		};

		var alternate_2 = ($$anchor) => {
			var fragment_6 = root_7();
			var node_5 = $.sibling($.first_child(fragment_6));

			$.add_svelte_meta(() => Booking(node_5, {}), 'component', Live, 50, 4, { componentTag: 'Booking' });
			$.next();
			$.append($$anchor, fragment_6);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.strict_equals($.get(mode), "choose")) $$render(consequent_3); else if ($.strict_equals($.get(mode), "now")) $$render(consequent_5, 1); else $$render(alternate_2, -1);
			}),
			'if',
			Live,
			31,
			2
		);
	}

	$.next();
	$.reset(div);

	$.template_effect(() => {
		$.set_class(span_2, 1, $.clsx([
			"relative size-3",
			$.get(open) ? "bg-ink" : "border-2 border-ink"
		]));

		$.set_text(text, $.get(open) ? "We're in right now" : "We're offline");
		$.set_text(text_1, `Paris, ${$.get(clock) ?? ''}`);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Live = $.hmr(Live);

	import.meta.hot.accept((module) => {
		Live[$.HMR].update(module.default);
	});
}

export default Live;

$.delegate(['click']);